import { render, staticRenderFns } from "./LoginPainel.vue?vue&type=template&id=8ab877fe&scoped=true&"
import script from "./LoginPainel.vue?vue&type=script&lang=js&"
export * from "./LoginPainel.vue?vue&type=script&lang=js&"
import style0 from "./LoginPainel.vue?vue&type=style&index=0&id=8ab877fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ab877fe",
  null
  
)

export default component.exports